module.exports = require('./dist/lib/head')



//////////////////
// WEBPACK FOOTER
// ./node_modules/next/head.js
// module id = ./node_modules/next/head.js
// module chunks = 6 9 11